import React from 'react'
import { withRouter } from 'react-router-dom'

function MenuBar(props) {
    const toAssessment = () => {
        props.history.push("/analytics")
    }
    const toSignup = () => {
        props.history.push("/signup")
    }
    const toCart = () => {
        props.history.push("/cart")
    }

    const toSideBar = () => {
        props.history.push("/sidebar")
    }

    const toGrocery = () => {
        props.history.push("/grocerylist")
    }

    return (
        <div className="MenuBar">
            <i className="material-icons hamburger clickable">menu</i>
            <div className="title">kitchen.it</div>
            <div className="icons">
                <i className="material-icons clickable" onClick={toSignup}>account_circle</i>
                <i className="material-icons clickable" onClick={toCart}>shopping_cart</i>
                <i className="material-icons clickable" onClick={toAssessment}>assessment</i>
                <i className="material-icons clickable" onClick={toSideBar}>drag_indicator</i>
                <i className="material-icons clickable" onClick={toGrocery}>add_shopping_cart</i>
            </div>
        </div>
    )
}

export default withRouter(MenuBar)